import TaxonomyTerm from "../../types/TaxonomyTerm";
import { TaxonomyAction, TaxonomyState } from "./TaxonomyState";

export const DISPATCH = 'WIS/taxonomy/military_status/DISPATCHED';
export const FULFILL = 'WIS/taxonomy/military_status/FULFILLED';
export const REJECT = 'WIS/taxonomy/military_status/REJECTED';

export type MilitaryStatusActionTypes = 
  'WIS/taxonomy/military_status/DISPATCHED'
  | 'WIS/taxonomy/military_status/FULFILLED'
  | 'WIS/taxonomy/military_status/REJECTED';

export const dispatch = () => ({ type: DISPATCH });
export const fulfill = (payload: TaxonomyTerm[]) => ({ type: FULFILL, payload });
export const reject = (error: string) => ({ type: REJECT, error });

const initialState: TaxonomyState = {
  terms: [],
  isFetching: false,
  isFetched: false,
  error: null,
};

export type TaxonomyMilitaryStatusAction = TaxonomyAction<MilitaryStatusActionTypes>;

export default function reducer(state = initialState, action: TaxonomyMilitaryStatusAction) {
  switch (action.type) {
    case DISPATCH:
      return {
        ...state,
        isFetching: true,
      };

    case FULFILL:
      return {
        ...state,
        terms: action.payload,
        isFetching: false,
        isFetched: true,
        error: null,
      };

    case REJECT:
      return {
        ...state,
        error: action.error,
        isFetching: false,
      };

    default:
      return state;
  }
}
